import { getCookie, setCookie } from 'util/cookie-utils'
import { hostsConfig } from 'init/config'

export type EventType = 'load'
export type Widget = 'chatter' | 'feed-comment-capture' | 'comments-pinboard' |
              'comments-pinboard-teaser' | 'gallery' | 'qa' |
              'reviews-list' | 'reviews-summary' | 'spectrum' |
              'subdimension-teaser' | 'top-comments' | 'vc-pinboard' | 'teaser'

interface TrackingEvent {
  cts: string
  svid: string
  et: EventType
  sk: string
  sku?: string
  wg: Widget
  ua: string
}

const eventQueue = []
let isSendingEvent = false

const TTSVID_COOKIE_NAME = 'TTSVID'
const VISIT_SESSION_TIMEOUT_MINUTES = 30

function queueEvent(widget: Widget, eventType: EventType, sku: string = null) {
  const event = { wg: widget, et: eventType, sku }
  eventQueue.push(event)
  postEvents()
}

function postEvents() {
  if (!isSendingEvent) {
    isSendingEvent = true
    while (eventQueue.length) {
      const el = eventQueue.shift()
      const event = createEvent(el.wg, el.et, el.sku)
      postWebEvent(event)
    }
    isSendingEvent = false
  }
}

function createEvent(widget: Widget, eventType: EventType, sku: string) {
  const event  = {
    cts: new Date().toJSON(),
    svid: getSVID(),
    et: eventType,
    sk: hostsConfig.siteKey,
    wg: widget,
    ua: navigator.userAgent
  } as TrackingEvent
  if (sku) {
    event.sku = sku
  }

  return event
}

function postWebEvent(payload: TrackingEvent) {
  const body = JSON.stringify(payload)
  const xhr: TTXMLHttpRequest<any> = new XMLHttpRequest()
  const url = hostsConfig.analyticsHost
  xhr.open('POST', url)
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send(body)
}

function getSVID() {
  let svid = getCookie(TTSVID_COOKIE_NAME)
  if (!svid) {
    svid = uuidv4()
  }
  setCookie(TTSVID_COOKIE_NAME, svid, VISIT_SESSION_TIMEOUT_MINUTES * 60)

  return svid
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export default { queueEvent }
